import * as fromDatatype from '../datatype-library/index';

export interface bl_hc_patient_appointment_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  patient_guid: fromDatatype.GuidDataFieldInterface;
  professional_guid: fromDatatype.GuidDataFieldInterface;
  appointment_no: fromDatatype.VarcharDatatypeInterface;
  appointment_date: fromDatatype.VarcharDatatypeInterface;
  appointment_time: fromDatatype.VarcharDatatypeInterface;
  booking_for: fromDatatype.VarcharDatatypeInterface;
  date_of_birth: fromDatatype.VarcharDatatypeInterface;
  reason_to_visit: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: any;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_hc_patient_appointment_hdr_RowClass implements bl_hc_patient_appointment_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  patient_guid: fromDatatype.GuidDataFieldInterface;
  professional_guid: fromDatatype.GuidDataFieldInterface;
  appointment_no: fromDatatype.VarcharDatatypeInterface;
  appointment_date: fromDatatype.VarcharDatatypeInterface;
  appointment_time: fromDatatype.VarcharDatatypeInterface;
  booking_for: fromDatatype.VarcharDatatypeInterface;
  date_of_birth: fromDatatype.VarcharDatatypeInterface;
  reason_to_visit: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: any;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}